import { render, staticRenderFns } from "./locomotion.vue?vue&type=template&id=19a144bc&"
import script from "./locomotion.vue?vue&type=script&lang=js&"
export * from "./locomotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports